/**
 * Formats a number by:
 * - Showing exactly 2 digits after the decimal point.
 * - Adding a '+' sign for positive numbers.
 * - Keeping the '-' for negative numbers.
 *
 * @param number - The number to format.
 * @returns The formatted string with sign.
 */
export const formatWithSign = (number: number): string => {
  const formatted = number.toFixed(2);
  return (number >= 0 ? "+" : "") + formatted;
};
